import { render, staticRenderFns } from "./Trunks.vue?vue&type=template&id=05a984ff&scoped=true&"
import script from "./Trunks.vue?vue&type=script&lang=js&"
export * from "./Trunks.vue?vue&type=script&lang=js&"
import style0 from "./Trunks.vue?vue&type=style&index=0&id=05a984ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a984ff",
  null
  
)

export default component.exports